<template>
  <div class="min-h-screen bg-white dark:bg-dark-bg">
    <!-- Header Section -->
    <div class="bg-gradient-to-br from-primary to-primary-700 dark:from-dark-surface dark:to-dark-bg py-20 mt-20">
      <div class="container-custom">
        <!-- Breadcrumb -->
        <nav class="mb-6">
          <ol class="flex items-center space-x-2 text-sm text-white/80">
            <li>
              <router-link to="/" class="hover:text-white transition-colors">
                Home
              </router-link>
            </li>
            <li><ChevronRight :size="16" /></li>
            <li class="text-white font-medium">{{ title }}</li>
          </ol>
        </nav>

        <!-- Page Title -->
        <h1 class="text-4xl md:text-5xl font-display font-bold text-white mb-4">
          {{ title }}
        </h1>
        <p v-if="subtitle" class="text-xl text-white/90 max-w-3xl">
          {{ subtitle }}
        </p>

        <!-- Last Updated -->
        <p v-if="lastUpdated" class="text-sm text-white/70 mt-6">
          Last Updated: {{ lastUpdated }}
        </p>
      </div>
    </div>

    <!-- Content Section -->
    <div class="container-custom py-16">
      <div class="max-w-4xl mx-auto">
        <slot />
      </div>
    </div>

    <!-- CTA Section -->
    <div v-if="showCTA" class="bg-gray-50 dark:bg-dark-surface border-t border-gray-200 dark:border-dark-border py-16">
      <div class="container-custom text-center">
        <h2 class="text-3xl font-display font-bold text-gray-900 dark:text-white mb-4">
          Have Questions?
        </h2>
        <p class="text-xl text-gray-600 dark:text-gray-300 mb-8">
          Our team is here to help you understand how we handle your data and protect your privacy.
        </p>
        <router-link to="/#contact" class="btn-primary">
          Contact Us
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ChevronRight } from 'lucide-vue-next';

defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  lastUpdated: {
    type: String,
    default: ''
  },
  showCTA: {
    type: Boolean,
    default: true
  }
});
</script>
